<template>
  <div class="notfound">
    <img class="imgpage imgBase" src="../assets/img/404not.jpg" alt="">
  </div>
</template>

<script>
  export default {
    
  }
</script>

<style lang="less" scoped>
.notfound{
  width: 100%;
  height: 100vh;
  box-sizing: border-box;
  text-align: center;
  font-size: 0;
  .imgpage{
    // width: 100%;
    height: 100%;
    // object-fit: cover;
  }
}
</style>